import { supabase } from "@/lib/supabase/client";
import { PROFILE_COLUMNS } from "@/features/identity/api/profileApi";

const inflight = new Map();

async function selectOwnProfile(userId) {
  const { data, error } = await supabase.from("profiles").select(PROFILE_COLUMNS).eq("user_id", userId).maybeSingle();
  if (error) throw error;
  return data;
}

async function createOrLoad(user) {
  const existing = await selectOwnProfile(user.id);
  if (existing) return existing;
  const fullName = user.user_metadata?.full_name?.trim() || null;
  const { data, error } = await supabase
    .from("profiles")
    .insert({ user_id: user.id, email: user.email, full_name: fullName })
    .select(PROFILE_COLUMNS)
    .single();
  if (!error) return data;
  if (error.code === "23505") {
    const again = await selectOwnProfile(user.id);
    if (again) return again;
  }
  throw error;
}

// Deduped per user so StrictMode / repeated auth events never race two inserts.
export function ensureProfile(user) {
  if (inflight.has(user.id)) return inflight.get(user.id);
  const promise = createOrLoad(user).finally(() => inflight.delete(user.id));
  inflight.set(user.id, promise);
  return promise;
}
